"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameReadingRoles = exports.ProducerRolesWithoutNameReading = exports.ProducerRoles = void 0;
const user_role_1 = require("../user-role");
exports.ProducerRoles = [
    user_role_1.UserRole.Admin,
    user_role_1.UserRole.HerffJonesAdmin,
    user_role_1.UserRole.MarchingOrderAdmin,
    user_role_1.UserRole.Producer,
    user_role_1.UserRole.InstitutionAdmin,
    user_role_1.UserRole.AVUser,
    user_role_1.UserRole.NameReadingAdmin,
    user_role_1.UserRole.NameReadingReviewer,
    user_role_1.UserRole.Api,
    user_role_1.UserRole.SelfUser,
];
exports.ProducerRolesWithoutNameReading = [
    user_role_1.UserRole.Admin,
    user_role_1.UserRole.HerffJonesAdmin,
    user_role_1.UserRole.MarchingOrderAdmin,
    user_role_1.UserRole.Producer,
    user_role_1.UserRole.InstitutionAdmin,
    user_role_1.UserRole.AVUser,
    user_role_1.UserRole.Api,
];
exports.NameReadingRoles = [user_role_1.UserRole.NameReadingAdmin, user_role_1.UserRole.NameReadingReviewer];
//# sourceMappingURL=producer-roles.js.map